import { render } from "./VolcanoCharts.vue?vue&type=template&id=27915ecc&scoped=true&ts=true"
import script from "./VolcanoCharts.vue?vue&type=script&lang=ts"
export * from "./VolcanoCharts.vue?vue&type=script&lang=ts"

import "./VolcanoCharts.vue?vue&type=style&index=0&id=27915ecc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27915ecc"]])

export default __exports__